import PropTypes from 'prop-types';
import { useState, useRef, useEffect } from 'react';

import { styled } from '@material-ui/core/styles';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Stack,
  Drawer,
  Divider,
  Typography,
  Card
} from '@material-ui/core';
//
import Scrollbar from '../../components/Scrollbar';
import apiContact from '../../api/contact';
import apiTeam from '../../api/team';
import apiUser from '../../api/user';
import { useSnackbar } from 'notistack5';
import { useTranslation } from 'react-i18next';
import AlertDialogContact from '../../components/_dashboard/zalo/DialogContact';
// ----------------------------------------------------------------------
import useAuth from '../../hooks/useAuth'
import TabContactGeneral from './tab/TabContactGeneral';
import TabContactOther from './tab/TabContactOther';
import MyAvatar from '../../components/MyAvatar';

FormActionContact2.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  card: PropTypes.object,
  onDeleteTask: PropTypes.func
};

const LabelStyle = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  width: 140,
  fontSize: 13,
  flexShrink: 0,
  color: theme.palette.text.secondary
}));



// ----------------------------------------------------------------------
const ADD_SYSTEM = "system";
export default function FormActionContact2({ phoneNumberSelect, type, infoContact, participants, card, isOpen, onClose, onDeleteTask, setIsRefreshContact, setCheckAddContact, isRefreshContact }) {
  const [currentTab, setCurrentTab] = useState('general');
  const fileInputRef = useRef(null);
  const [taskCompleted, setTaskCompleted] = useState(card?.completed);
  const [prioritize, setPrioritize] = useState('low');
  const system = 'system'
  const participant = type === ADD_SYSTEM ? null : [...participants][0];
  const [openDialog, setOpenDialog] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const [infoContactSelected, setInfoContactSelected] = useState();
  const [departmentSelected, setDepartmentSelected] = useState();
  const [departments, setDepartments] = useState([]);
  const { user } = useAuth();
  const [fieldContact, setFieldContact] = useState([]);
  const [validation, setValidation] = useState({
    name: Yup.string().required('Họ và tên không được bỏ trống!'),
    //email: Yup.string().required('Email không được bỏ trống!').email(),
    // phone: Yup.string().required('Số điện thoại không được bỏ trống!'),
    //text: Yup.string().required('Text không được bỏ trống!'),
    //notes: Yup.string().required('Ghi chú không được bỏ trống!')
  });
  const [initialValues, setInitialValues] = useState({});

  const onCloseDialog = () => {
    setOpenDialog(false);
  }

  const handleAttach = () => {
    fileInputRef.current.click();
  };

  const handleToggleCompleted = () => {
    setTaskCompleted((prev) => !prev);
  };

  const handleChangePrioritize = (event) => {
    setPrioritize(event.target.value);
  };
  const handleOnchange = (e) => {
    if (e.target.name === "customer_name") {
    }
    console.log(e.target.value)
  }
  const onChangeUserCreate = (e) => {
    setFieldValue("assigned_by", e.target.value)

  }
  var NewUserSchema = Yup.object().shape(validation);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        values.from = type;
        if (type === "zalo" || type === "quick_edit_zalo") {
          values.uid = participant.uid;
          values.oa_id = participant.oa_id
        }
        if (type === "facebook" || type === 'quick_edit_facebook') {
          values.uid = participant.user_id;
          values.page_id = participant.page_id;
        }
        if (type === "plugin" || type === 'quick_edit_plugin') {
          values.uid = participant.user_id;

        }
        if ((type === "system" || type === "facebook" || type === "zalo" || type === "plugin" || type === 'quick_edit_zalo' || type === 'quick_edit_facebook' || type === "quick_edit_plugin" || type === 'quick_callhistory') && (phoneNumberSelect !== infoContact.phone || typeof (phoneNumberSelect) === "undefined")) {
          //Nếu tồn tại danh bạ thì thêm type system ngược lại thêm lại zalo hoặc facebook
          if (Object.keys(infoContact).length === 0) {
            if (type === "quick_edit_zalo") {
              values.uid = participant.uid;
              values.oa_id = participant.oa_id
              values.from = "system";
            }
            if (type === "quick_edit_facebook") {
              values.uid = participant.user_id;
              values.page_id = participant.page_id;
              values.from = "system";
            }
            if (type === "quick_edit_plugin") {
              values.uid = participant.user_id;
              values.from = "system";
            }
            if (type === 'quick_callhistory') {
              values.from = "system";
            }
            // values.from = type === "quick_edit_zalo" ? "zalo" : "facebook";
          } else {
            values.from = "system";
          }
          await apiContact.add(values);
          enqueueSnackbar('Thêm liên hệ thành công', { variant: 'success' });
          setIsRefreshContact(true);
          resetForm();
          onClose();
        } else {
          await apiContact.quick_edit(values);
          enqueueSnackbar('Cập nhật liên hệ thành công', { variant: 'success' });
          setIsRefreshContact(true);
          resetForm();
          onClose();
        }
        setCheckAddContact(true);

      } catch (error) {
        enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
        if (error.response.data.message[0] === "Đã tồn tại danh bạ") {
          const res_info_contact = await apiContact.find(values);
          setInfoContactSelected(res_info_contact.data.data);
          setOpenDialog(true);
        }
      }
    }
  });
  const { values, handleSubmit, setFieldValue } = formik;
  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue);
  };
  let isMountedDepartment = true; // Track if the component is still mounted
  
  const load_department = async () => {
    try {
      const res_departments = await apiTeam.listDepartment();
      if (isMountedDepartment) {
        setDepartments(res_departments.data.data);
      }
    } catch (error) {
      console.error('Error loading departments:', error);
    }
  };
  useEffect(() => {
    load_department();
    return () => {
      isMountedDepartment = false; // Cleanup on unmount
    };
  }, []);

  // useEffect(() => {
  //   const load_field_contact = async () => {
  //     const res_field_contact = await apiContact.list_field_contact();
  //     setFieldContact(res_field_contact.data.data);
  //     var validations = validation;
  //     if (phoneNumberSelect === infoContact.phone) {
  //       var arr_initialValues = {
  //         name: infoContact.name || participant?.display_name,
  //         email: infoContact.email || '',
  //         phone: phoneNumberSelect ? phoneNumberSelect : infoContact.phone ? infoContact.phone : '',
  //         notes: infoContact.notes || '',
  //         company: infoContact.company || '',
  //         address: infoContact.address || '',
  //         assigned_by: infoContact.assigned_by || user.id,
  //       };
  //     } else {
  //       var arr_initialValues = {
  //         name: participant?.display_name,
  //         email: '',
  //         phone: phoneNumberSelect ? phoneNumberSelect : '',
  //         notes: '',
  //         company: '',
  //         address: '',
  //         assigned_by: user.id,
  //       };
  //     }

  //     res_field_contact.data?.data?.map((item) => {
  //       if (item.field_condition.includes('required')) {
  //         if (item.field_type === "email") {
  //           validations = { ...validations, [item.field_variable]: Yup.string().email('Invalid email').required(item.field_name + ' không được bỏ trống!') };
  //         }
  //         else if (item.field_type === "number") {
  //           validations = { ...validations, [item.field_variable]: Yup.number('Invalid number').required(item.field_name + ' không được bỏ trống!') };
  //         } else if (item.field_type === "dateTime") {
  //           validations = { ...validations, [item.field_variable]: Yup.date('Invalid datetime').required(item.field_name + ' không được bỏ trống!') };
  //         } else {
  //           validations = { ...validations, [item.field_variable]: Yup.string().required(item.field_name + ' không được bỏ trống!') };
  //         }
  //       }
  //       arr_initialValues = { ...arr_initialValues, [item.field_variable]: infoContact[item.field_variable] || '' };
  //     })

  //     setValidation(validations);
  //     setInitialValues(arr_initialValues)
  //   }

  //   load_field_contact();

  //   // }, [infoContact, phoneNumberSelect]);
  // }, [infoContact, phoneNumberSelect]);
  
  useEffect(() => {
    let isMounted = true; // Flag to track if the component is mounted
  
    const load_field_contact = async () => {
      try {
        const res_field_contact = await apiContact.list_field_contact();
        if (isMounted) {
          setFieldContact(res_field_contact.data.data);
        }
  
        let validations = validation;
        let arr_initialValues;
        
        if (phoneNumberSelect === infoContact.phone) {
          arr_initialValues = {
            name: infoContact.name || participant?.display_name,
            email: infoContact.email || '',
            phone: phoneNumberSelect || infoContact.phone || '',
            notes: infoContact.notes || '',
            company: infoContact.company || '',
            address: infoContact.address || '',
            assigned_by: infoContact.assigned_by || user.id,
          };
        } else {
          arr_initialValues = {
            name: participant?.display_name,
            email: '',
            phone: phoneNumberSelect || '',
            notes: '',
            company: '',
            address: '',
            assigned_by: user.id,
          };
        }
  
        res_field_contact.data?.data?.forEach((item) => {
          if (item.field_condition.includes('required')) {
            if (item.field_type === 'email') {
              validations = {
                ...validations,
                [item.field_variable]: Yup.string()
                  .email('Invalid email')
                  .required(`${item.field_name} không được bỏ trống!`),
              };
            } else if (item.field_type === 'number') {
              validations = {
                ...validations,
                [item.field_variable]: Yup.number('Invalid number').required(`${item.field_name} không được bỏ trống!`),
              };
            } else if (item.field_type === 'dateTime') {
              validations = {
                ...validations,
                [item.field_variable]: Yup.date('Invalid datetime').required(`${item.field_name} không được bỏ trống!`),
              };
            } else {
              validations = {
                ...validations,
                [item.field_variable]: Yup.string().required(`${item.field_name} không được bỏ trống!`),
              };
            }
          }
          if (item.is_default === 0) {
            const selected_field_contact_other = infoContact?.other?.length > 0 ? infoContact.other.filter((i) => i.k === item.field_variable) : [];
            arr_initialValues = { ...arr_initialValues, [item.field_variable]: selected_field_contact_other.length > 0 ? selected_field_contact_other[0].v : '' || '' };

          } else {
            arr_initialValues = { ...arr_initialValues, [item.field_variable]: infoContact[item.field_variable] || '' };
          }
          // arr_initialValues = {
          //   ...arr_initialValues,
          //   [item.field_variable]: infoContact[item.field_variable] || '',
          // };
        });
  
        if (isMounted) {
          setValidation(validations);
          setInitialValues(arr_initialValues);
        }
      } catch (error) {
        console.error('Error loading field contact:', error);
      }
    };
  
    load_field_contact();
  
    return () => {
      isMounted = false; // Cleanup to avoid updates when the component is unmounted
    };
  }, [infoContact, phoneNumberSelect]); // Dependency array
  
  const onChangeDepartment = (e) => {
    setDepartmentSelected({ name: e.target.name, value: e.target.value });
  }
  return (
    <>
      <Drawer open={isOpen} onClose={onClose} anchor="right" PaperProps={{ sx: { width: { xs: 1, sm: 690 } } }}>
        <Card
          sx={{
            backgroundColor: '#303187',
            py: 7,
            display: 'flex',
            position: 'relative',
            alignItems: 'center',
            flexDirection: 'column',
            borderRadius: '0px 0px 32px 32px',
            boxShadow: '0 0 0 5px #EF4137',
            borderBottom: '5px solid #48C8F4',
            height: '190px'
          }}
        >
          <Stack direction={"column"} justifyContent="center" alignItems="center" sx={{ mt: '-40px' }} >
            <MyAvatar fontSize={'50px'} width={'76px'} height={'76px'} alt={user.full_name} sx={{ mb: 3 }} />
            <Typography to="#" variant="subtitle1" sx={{ fontSize: '20px', fontWeight: '700', color: '#FEFEFE', lineHeight: '24px', mt: 2 }}>
              {user.full_name}
            </Typography>
            <Typography variant="body2" sx={{ color: '#FEFEFE' }}>
              {user?.title_team}
            </Typography>
          </Stack>
        </Card>
        <Scrollbar sx={{ mt: 2 }}>
          <Stack sx={{ p: 2 }}>
            <FormikProvider value={formik}>
              <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                <Typography></Typography>
                <TabContactGeneral onChangeDepartment={onChangeDepartment} departments={departments} departmentSelected={departmentSelected} setCurrentTab={setCurrentTab} infoContact={infoContact} setIsRefreshContact={setIsRefreshContact} formik={formik} />
                <Typography></Typography>
                <TabContactOther phoneNumberSelect={phoneNumberSelect} type={type} setCurrentTab={setCurrentTab} infoContact={infoContact} formik={formik} fieldContact={fieldContact} />
              </Form>
            </FormikProvider>
          </Stack>
        </Scrollbar>
        <Divider />
        {openDialog &&
          <AlertDialogContact infoNew={values} type={type} infoContactSelected={infoContactSelected} uid={type === "zalo" ? participant?.uid : participant?.user_id} open={openDialog} setIsRefreshContact={setIsRefreshContact} onClose={() => onCloseDialog(false)} onCloseForm={() => onClose()}></AlertDialogContact>
        }
      </Drawer>
    </>
  );
}
